// src/pages/Subscription/SubscriptionFailurePage.jsx
import React from 'react';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import { useLocation, Link } from 'react-router-dom';
import {
  RiCloseCircleFill,
  RiArrowRightLine,
  RiRefreshLine,
  RiCustomerService2Line,
  RiAlertLine,
} from 'react-icons/ri';

const SubscriptionFailurePage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const errorMsg = query.get('error') || query.get('msg') || 'Transaction was cancelled or declined by the payment bank.';
  const txnid = query.get('txnid');

  return (
    <div className="page-content d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={7} lg={6}>
            <Card className="border-0 shadow-lg text-center overflow-hidden" style={{ borderRadius: 16 }}>
              <div className="bg-danger py-4 text-white">
                <RiCloseCircleFill style={{ fontSize: 64 }} />
                <h4 className="text-white font-weight-bold mt-2 mb-0">Subscription Payment Failed</h4>
                <p className="text-white-50 font-size-13 mb-0">PayU Payment Gateway Notice</p>
              </div>

              <CardBody className="p-4">
                <div className="alert alert-danger font-size-13 text-start mb-4">
                  <div className="d-flex align-items-start gap-2">
                    <RiAlertLine className="font-size-20 flex-shrink-0 mt-0.5" />
                    <div>
                      <strong>Decline Reason:</strong> {errorMsg}
                      {txnid && (
                        <div className="mt-1 font-size-12 text-muted">
                          Reference TXN: <code>{txnid}</code>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <p className="text-muted font-size-13 mb-4">
                  No charges were permanently deducted. If your account was debited, the amount will automatically revert within 3–5 working days according to banking guidelines.
                </p>

                <div className="d-flex gap-2 justify-content-center flex-wrap">
                  <Button
                    color="primary"
                    tag={Link}
                    to="/subscription"
                    className="d-flex align-items-center gap-1"
                  >
                    <RiRefreshLine /> Retry Checkout
                  </Button>
                  <Button
                    color="light"
                    tag={Link}
                    to="/dashboard"
                    className="d-flex align-items-center gap-1"
                  >
                    Return to Dashboard
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SubscriptionFailurePage;
